import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "TranscriptCalculation" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = {
  key: 0,
  class: "mt-3 flex items-center justify-end"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.calculation.invoiceNumber), 1),
      _createElementVNode("p", null, "Итоговая стоимость: " + _toDisplayString(_ctx.calculation.finalPaymentAmount), 1)
    ]),
    (_ctx.isCanRenderPrintButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_the_button, {
            class: "primary small text",
            loading: _ctx.state.is_pdf_loading,
            onClick: _ctx.printDocuments
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" Печать документов ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}